import React, { useState, useEffect } from "react";
import { Table, Select, Input } from "antd";
import CalendarsModal from './CalendarsModal'
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { db } from '../../../db/db'

dayjs.extend(utc);
dayjs.extend(timezone);

function CalendarsTable() {
  const [data, setData] = useState()
  const [datesLoaded, setDatesLoaded] = useState(false);
  const [datesJson, setDatesJson] = useState();
  const [dateData, setDateData] = useState([{ label: '', value: '1' }])
  const [dateValue, setDateValue] = useState('0');
  const [info, setInfo] = useState({})
  const [open, setOpen] = useState(false);
  const [searchedText, setSearchedText] = useState("");

  const documentOptions = {
    '1': 'General Calendar',
    '2': 'Rules Calendar',
    '4': 'Local Calendar',
    '8': 'Miscellaneous Calendar',
    '16': 'First Readers',
    '32': 'Daily Status',
    '512': 'Composite',
    '2023': 'Rules Committee Consideration Calendar',
  }

  const chamberNumType = {
    H: 1,
    S: 2,
  };
  const documentNumType = {
    B: 1,
    R: 2,
  };

  const calendarsCol = [
    {
      title: 'Calendar Name',
      dataIndex: 'title',
      width: 180,
      key: 'title',
      filteredValue: [searchedText],
      onFilter: (value, record) => {
        return String(record.title)
          .toLowerCase()
          .includes(value.toLowerCase()) ||
          String(record.billsResolutions)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.chamber)
            .toLowerCase()
            .includes(value.toLowerCase())
      }
    },
    {
      title: 'Bills/Resolutions',
      key: 'billsResolutions',
      dataIndex: 'billsResolutions',
      width: 300,
      ellipsis: true,
    },
    {
      title: 'Type',
      key: 'type',
      dataIndex: 'type',
      width: 80,
      render: item => documentOptions[`${item}`]
    },
    {
      title: 'Chamber',
      key: 'chamber',
      dataIndex: 'chamber',
      width: 50,
    },
  ];

  const getCalendarData = () => {
    if (!datesLoaded) {
      db.collection('calendarDays').doc('1031').get()
        .then(doc => {
          const items = doc.data()
          return items
        })
        .then(calendars => calendars.days.map(doc => ({
          date: doc.date,
          day: doc.day,
        })))
        .then(days => {
          setDatesJson(days)
          const datesArr = [];
          for (let i = 0; i < days.length; i += 1) {
            datesArr.push({
              label: `Day ${days[i].day}: ${days[i].date.substring(0, 10)}`,
              value: i,
            })
          }
          return datesArr
        }).then(dates => {
          setDateData(dates)
          setDatesLoaded(true)
        })
    } else {
      const allDataArr = [];
      const selectedDate = datesJson[dateValue]?.date.split("T")[0]; // Extract YYYY-MM-DD

      // Query the allCalendars collection using db.collection()
      db.collection('allCalendars')
        .where("dayDate", "==", selectedDate) // Filter by dayDate
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            const calendarData = doc.data();
            allDataArr.push({
              pageType: 'Calendar',
              chamber: calendarData.chamber === 1 ? 'House' : 'Senate',
              title: calendarData.title,
              date: calendarData.date,
              billsResolutions: calendarData.billsResolutions?.join(', '),
              type: calendarData.type,
              attachmentLink: calendarData.url,
              key: calendarData.title,
            });
          });
          setData(allDataArr); // Set the data for the calendar
        });
    }

  }

  useEffect(() => {
    getCalendarData()
  }, [datesLoaded, dateValue])


  const rowClicked = (e, record) => {
    console.log('rowClicked')
    console.log(record)
    const data = {
      ...record
    }
    setInfo(data)
  };

  const onSubmit = async (saveData) => {
    const bills = saveData.billsResolutions?.replace(/\s/g, '').split(',');

    const updatedCalObj = {
      date: info.date ? dayjs(info.date).tz('America/New_York').startOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]') : null,
      chamber: saveData.chamber === 'House' ? 1 : 2,
      billsResolutions: bills ? bills : null,
      title: saveData.title ? saveData.title : null,
      type: saveData.type ? saveData.type : null,
      url: saveData.attachmentLink ? saveData.attachmentLink : null,
      dayDate: info.date ? dayjs(info.date).format('YYYY-MM-DD') : null, // Add dayDate (YYYY-MM-DD format)
    };
    console.log(updatedCalObj)

    await db.collection('allCalendars').doc(saveData.title).set(updatedCalObj, { merge: true });
    await addCalendarToBills(updatedCalObj)
    getCalendarData();
    setOpen(false);
  };

  const addCalendarToBills = async (calendar) => {
    for (let i = 0; i < calendar.billsResolutions.length; i += 1) { // loop through the billsResolutions of the current calendar
      const bill = calendar.billsResolutions[i]; // the current single bill in the calendar's billsResolutions

      try {
        await db.collection("legislation")
          .where('chamber', '==', chamberNumType[bill[0]])
          .where('documentType', '==', documentNumType[bill[1]])
          .where('number', '==', bill.substring(2))
          .get()
          .then((querySnapshot) => {   // search the db for the bill
            const billHistoryArr = [];
            querySnapshot.forEach((doc) => {
              const item = doc.data();  // the legislation in the db that matches the current bill
              if (item.billHistory) {  // list of the meetings and calendars that the bill has been a part of 
                billHistoryArr.push(...item.billHistory); // pushing what's already in the bill to our new array
              }
              // Check if the current calendar is already in the bill's history
              if (!item.billHistory?.find(o => o.name === calendar.title)) {
                // Add the current calendar to the bill's history
                billHistoryArr.push({
                  name: calendar.title,
                  date: calendar.date,
                  type: "Calendar",
                });
                db.collection('legislation').doc(`${item.id}`).update({
                  billHistory: billHistoryArr
                });
              }
            });
          });
      } catch (error) {
        console.log(`Error fetching bill for calendar, addCalendarToBills`);
      }
    }
  };

  const onDelete = (saveData) => {
    try {
      // Step 1: Delete the calendar from 'allCalendars'
      db.collection('allCalendars').doc(saveData.title).delete()
        .then(() => {
          const billsArr = saveData.billsResolutions.split(',').map(bill => bill.trim());
          // Step 3: Loop through the billsResolutions for the calendar being deleted
          billsArr.forEach((bill) => {
            db.collection("legislation")
              .where('chamber', '==', chamberNumType[bill[0]])
              .where('documentType', '==', documentNumType[bill[1]])
              .where('number', '==', bill.substring(2))
              .get()
              .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                  const item = doc.data();
                  const updatedBillHistory = item.billHistory?.filter(
                    (historyItem) => historyItem.name !== saveData.title
                  ) || [];

                  // Update the billHistory in Firestore
                  db.collection('legislation').doc(`${item.id}`).update({
                    billHistory: updatedBillHistory,
                  });
                });
              });
          });

          // Close the modal or perform any necessary UI update
          getCalendarData();
          setOpen(false);
        });
    } catch (error) {
      console.error("Error deleting calendar entry:", error);
    }
  };

  const onClick = (value) => {
    setDateValue(`${value}`)
  };

  const menuProps = {
    items: dateData,
    onClick,
  };
  const centerPagination = "bottomCenter";
  return (
    <div>
      <Select
        style={{ width: 180 }}
        className='calendarDropdown'
        showSearch
        placeholder='Search Calendars'
        value={dateData[dateValue]}
        optionFilterProp="label"
        onChange={onClick}
        filterOption={(input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
        options={dateData}
      />
      <Input.Search
        placeholder='Search Calendars'
        style={{ marginBottom: 8 }}
        onSearch={(value) => {
          setSearchedText(value);
        }}
        onChange={(e) => {
          setSearchedText(e.target.value)
        }}
      />
      <Table
        onRow={(record) => ({
          onClick: (event) => {
            rowClicked(event, record);
          },
        })}
        bordered
        size={'small'}
        columns={calendarsCol}
        dataSource={data}
        pagination={{
          position: [centerPagination],
          hideOnSinglePage: true,
        }}
        scroll={{ y: 500 }}
        footer={() =>
          <CalendarsModal
            info={info}
            setInfo={setInfo}
            onSubmit={onSubmit}
            open={open}
            setOpen={setOpen}
            onDelete={onDelete}
          />
        }
      />
    </div>
  );
}

export default CalendarsTable